var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dm-flex-1 dm-flex-grow dm-min-h-1 dm-w-full"},[_c('iframe',{attrs:{"height":"100%","width":"100%","src":("" + _vm.pdfUrl)}})])}
var staticRenderFns = []

export { render, staticRenderFns }